import { useEffect, useState } from 'react'

export const useHashParams = () => {
  const [param, setParam] = useState()

  const clear = () => {
    setParam(undefined)
    if (window?.location?.hash === param) {
      window.history.pushState(
        '',
        document.title,
        window.location.pathname + window.location.search
      )
    }
  }

  const set = (key) => {
    window.location.hash = key
  }

  useEffect(() => {
    const checkHash = () => {
      if (window?.location?.hash) {
        setParam(window?.location?.hash)
      } else {
        clear()
      }
    }

    checkHash()
    window.addEventListener('hashchange', checkHash)
    return () => {
      window.removeEventListener('hashchange', checkHash)
    }
  }, [])

  return { param, set, clear }
}
